import api from '../api/axios';

export const insuranceClientService = {
  async getAll(params?: any) {
    const defaultParams = {
      'populate[servicePackage]': '*',
      'populate[insuranceCompany]': '*',
      ...params
    };
    const response = await api.get('/insurance-clients', { params: defaultParams });
    return response.data;
  },

  async getOne(id: number) {
    // Populate all relations including nested ones for detailed view
    // Using params object to properly handle nested populate
    const response = await api.get(`/insurance-clients/${id}`, {
      params: {
        'populate[requests][populate]': '*',
        'populate[serviceUsages]': '*',
        'populate[insuranceCompany]': '*',
        'populate[servicePackage]': '*'
      }
    });
    return response.data.data;
  },

  async getByVin(vinNumber: string) {
    const response = await api.get(`/insurance-clients?filters[vinNumber][$eq]=${vinNumber}&populate=*`);
    return response.data.data;
  },

  /**
   * Get fleets: policy numbers that have more than one client.
   * Only returns groups where the same policy number appears on 2+ clients.
   */
  async getFleets() {
    const response = await api.get('/insurance-clients/fleets');
    return response.data;
  },

  async create(data: any) {
    const response = await api.post('/insurance-clients', { data });
    return response.data.data;
  },

  async update(id: number, data: any) {
    const response = await api.put(`/insurance-clients/${id}`, { data });
    return response.data.data;
  },

  async delete(id: number) {
    const response = await api.delete(`/insurance-clients/${id}`);
    return response.data;
  },

  async checkVin(vinNumber: string) {
    const response = await api.post('/insurance-clients/check-vin', { vinNumber });
    return response.data;
  },

  async checkVinWithNotification(vinNumber: string, needWhatsappMessage: boolean = false, customMessage?: string) {
    const response = await api.post('/insurance-clients/check-vin-with-notification', {
      vinNumber,
      needWhatsappMessage,
      customMessage
    });
    return response.data;
  },

  async checkEligibility(vinNumber: string, serviceCode: string) {
    const response = await api.post('/insurance-clients/check-eligibility', {
      vinNumber,
      serviceCode
    });
    return response.data;
  },

  async uploadClients(file: File, insuranceCompanyId: string) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('insuranceCompanyId', insuranceCompanyId);

    const response = await api.post('/insurance-clients/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Stream-based upload with real-time progress
  getUploadStreamUrl(file: File, insuranceCompanyId: string): { url: string; formData: FormData } {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('insuranceCompanyId', insuranceCompanyId);
    
    const baseUrl = api.defaults.baseURL || '';
    const url = `${baseUrl}/insurance-clients/upload-stream`;
    
    return { url, formData };
  },

  async downloadTemplate(insuranceCompanyId: string) {
    const response = await api.get(`/insurance-clients/download-template?insuranceCompanyId=${insuranceCompanyId}`, {
      responseType: 'blob'
    });
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `insurance_clients_template.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  }
};

